import React, { useMemo } from 'react'
import {
  Box,
  Text,
  Textarea
} from '@chakra-ui/react'
import { FastField, FieldAttributes } from 'formik'
import _ from 'lodash'

import { InputWrapper } from './input-wrapper'
import { FreetextFormInput } from '../form-types'

const maxLengthWarning = 10;
const defaultMaxLength = 5000;

interface FreetextInputProps {
  id: string;
  input: FreetextFormInput;
  isDisabled?: boolean;
}
// <span class="textarea" role="textbox" contenteditable></span>

export const FreetextInputComponent: React.FC<FreetextInputProps> = ({ input, id, isDisabled }) => {
  const maxLength = useMemo(() => {
    return input.meta?.maxLength || defaultMaxLength
  }, [input])

  return (
    <InputWrapper>
      <FastField name={id}>
        {({ field }: { field: FieldAttributes<any> }) => (
          <Box position="relative" sx={{
            breakBefore: 'auto',
            breakInside: 'avoid',
            breakAfter: 'avoid',
          }}>
            <Textarea {...field} placeholder={input.meta?.placeholder || ''} maxLength={maxLength} isDisabled={isDisabled} sx={{
              display: 'initial',
              '@media print': {
                display: 'none',
              },
              opacity: '1 !important'
            }} />
            {
              field.value && field.value.length && ((maxLength - field.value.length) <= maxLengthWarning) &&  (
                <Box textAlign="right" position="absolute" bottom="-24px" right="0px" sx={{
                  '@media print': {
                    display: 'none',
                  }
                }}>
                  {maxLength === field.value.length ? <Text color="severe">Max Character Limit</Text> : <Text color="light_gray">{`Characters Left: ${maxLength - field.value.length}`}</Text>}
                </Box>
              )
            }
            <Text sx={{
              minHeight: '80px',
              borderRadius: 'md',
              py: '8px',
              px: '12px',
              border: '1px solid',
              borderColor: 'light_gray',
              display: 'none',
              '@media print': {
                display: 'block',
              }
            }}>
              {field.value}
            </Text>
          </Box>
        )}
      </FastField>
    </InputWrapper>
  )
}

export const FreetextInput = React.memo((FreetextInputComponent), (prevProps, nextProps) => prevProps.id === nextProps.id && _.isEqual(prevProps.input, nextProps.input) )
